import React from 'react';
import clsx from "clsx";
import {BaseButtonTypes} from "../BaseButton.types";

export const ButtonBase: React.FC<BaseButtonTypes<HTMLButtonElement>> = (props) => {
    return (
        <button
            id={props.id}
            className={clsx(props.className)}
            onClick={props.onClick}
            ref={props.ref}
            disabled={props.disabled}
        >
            {props.children}
        </button>
    )
}
